import { ILocationGratuity } from '@ready/dashboardv2api.contracts';
import config from '../config';
import executeApiAsync from './utils/executeApiAsync';

export class TipConfigurationService {
  public static getTipConfiguration = (companyId: string, locationId: string): Promise<ILocationGratuity> => {
    const url = `${config.readyDashboardApiEndpoint}/companies/${companyId}/locations/${locationId}/tips`;
    return executeApiAsync<ILocationGratuity>(url);
  };

  public static updateTipConfiguration = (
    companyId: string,
    locationId: string,
    tipConfig: ILocationGratuity
  ): Promise<ILocationGratuity> => {
    const url = `${config.readyDashboardApiEndpoint}/companies/${companyId}/locations/${locationId}/tips`;
    return executeApiAsync<ILocationGratuity>(url, {
      method: 'PUT',
      body: JSON.stringify(tipConfig),
    });
  };
}